import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalPlaceholderComponent } from '../modal-placeholder.component';
import { HelpersService } from '../../../services/helpers.service';
import { GlobalModalService } from '../../../services/global-modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'interstitial-modal',
  imports: [
    ModalPlaceholderComponent
  ],
  templateUrl: './interstitial-modal.component.html',
  styleUrl: './interstitial-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterstitialModalComponent {

  @Input() url: string = '';

  constructor(
    private helpersService: HelpersService,
    private globalModalService: GlobalModalService,
    private activeModal: NgbActiveModal
  ) { }

  continue(url: string) {
    if (!this.helpersService.validatePlatform()) return;
    window.open(url, '_blank');
    this.close();
  }

  close() {
    this.globalModalService.setScrollingInPage();
    this.activeModal.close()
  }

}
